import TipTapHorizontalRule from '@tiptap/extension-horizontal-rule'

export const HorizontalRule = TipTapHorizontalRule.extend({
  addAttributes() {
    return {
      index: {
        default: -1,
        parseHTML: element => element.getAttribute('data-index'),
        renderHTML: attributes => ({ ['data-index']: attributes.index }),
      },
    }
  },
})
